import {makeObservable, observable} from 'mobx';
import {Capacitor} from '@capacitor/core';

const SESSION_TOKEN = 'session-token';

export class SessionRepository {

    @observable
    private token?: string = undefined;

    constructor() {
        makeObservable(this);
    }

    getJwt(): string | undefined {
        if (this.token) {
            return this.token;
        }

        const token = Capacitor.getPlatform() !== 'web' ? localStorage.getItem(SESSION_TOKEN) : sessionStorage.getItem(SESSION_TOKEN);

        if (token !== null) {
            return token;
        }
    }

    setJwt(jwt: string): void {
        if (Capacitor.getPlatform() !== 'web') {
            localStorage.setItem(SESSION_TOKEN, jwt);
        } else {
            sessionStorage.setItem(SESSION_TOKEN, jwt);
        }
        this.token = jwt;
    }

    clearJwt(): void {
        if (Capacitor.getPlatform() !== 'web') {
            localStorage.removeItem(SESSION_TOKEN);
        } else {
            sessionStorage.removeItem(SESSION_TOKEN);
        }
        this.token = undefined;
    }
}
